module.exports = __webpack_public_path__ + "img/food_pieceofcake.acec871a.png";